/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateSmsTfaOptionErrorResponse,
  UpdateSmsTfaOptionRequest,
  UpdateSmsTfaOptionResponse,
} from './api.schemas';

import { api } from '../util/http';

export const tfaSms = (updateSmsTfaOptionRequest: UpdateSmsTfaOptionRequest) => {
  return api<UpdateSmsTfaOptionResponse>({
    url: `/api/auth/tfa/sms`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSmsTfaOptionRequest,
  });
};

export const getTfaSmsMutationOptions = <
  TError = UpdateSmsTfaOptionErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tfaSms>>,
    TError,
    { data: UpdateSmsTfaOptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tfaSms>>,
  TError,
  { data: UpdateSmsTfaOptionRequest },
  TContext
> => {
  const mutationKey = ['tfaSms'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tfaSms>>,
    { data: UpdateSmsTfaOptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return tfaSms(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaSmsMutationResult = NonNullable<Awaited<ReturnType<typeof tfaSms>>>;
export type TfaSmsMutationBody = UpdateSmsTfaOptionRequest;
export type TfaSmsMutationError = UpdateSmsTfaOptionErrorResponse;

export const useTfaSms = <TError = UpdateSmsTfaOptionErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tfaSms>>,
      TError,
      { data: UpdateSmsTfaOptionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tfaSms>>,
  TError,
  { data: UpdateSmsTfaOptionRequest },
  TContext
> => {
  const mutationOptions = getTfaSmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
